import {
  Widgets2ChartData,
  Widgets2ChartData2,
  Widgets2ChartData2Widgets,
  Widgets2ChartDataWidgets,
} from "./Chart";

export const WidgetsData = {
  title: "Số hộ nghèo",
  gros: 50,
  total: 10_000,
  color: "secondary",
  icon: "stroke-user",
};
export const WidgetsData2 = {
  title: "Số hộ cận nghèo",
  gros: 20,
  total: 7000,
  color: "secondary",
  icon: "stroke-user",
};
export const WidgetsData3 = {
  title: "Tổng phiếu điều tra",
  gros: 70,
  total: 4_200,
  color: "primary",
  icon: "tag",
};
export const WidgetsData4 = {
  title: "Tổng số báo cáo",
  gros: 70,
  total: 5700,
  color: "success",
  icon: "rate",
};

export const WidgetsData5 = {
  title: "Tổng số hộ gia đình",
  gros: 70,
  total: 5700,
  color: "success",
  icon: "fill-user",
};
export const WidgetsData1WidgetsPage = [
  {
    title: "Purchase",
    gros: 50,
    total: 10_000,
    color: "secondary",
    icon: "cart",
  },
  {
    title: "Sales return",
    gros: 20,
    total: 7000,
    color: "warning",
    icon: "return-box",
  },
  {
    title: "Sales",
    gros: 70,
    total: 4_200,
    color: "primary",
    icon: "tag",
  },
  {
    title: "Purchase rate",
    gros: 70,
    total: 5700,
    color: "success",
    icon: "rate",
  },
];

export const Widgets2Data = {
  title: "Orders",
  total: "1,80k",
  chart: Widgets2ChartData,
};
export const Widgets2Data2 = {
  title: "Profit",
  total: "6,90k",
  chart: Widgets2ChartData2,
};
export const Widgets2DataWidgets = {
  title: "Orders",
  total: "1,80k",
  chart: Widgets2ChartDataWidgets,
};
export const Widgets2Data2Widgets = {
  title: "Profit",
  total: "6,90k",
  chart: Widgets2ChartData2Widgets,
};

export const LightCardData = [
  {
    title: "Income",
    icon: "income",
    price: "$22,678",
    gros: "+$456",
    color: "success",
  },
  {
    title: "Expense",
    icon: "expense",
    price: "$12,057",
    gros: "+$256",
    color: "danger",
  },
  {
    title: "Cashback",
    icon: "doller-return",
    price: "$8,475",
  },
];
export const LightCardData2 = [
  {
    title: "Đã hoàn thành",
    icon: "orders",
    price: "10,098",
    color: "success",
  },
  {
    title: "Chờ nộp ngân sách",
    icon: "expense",
    price: "$12,057",
    color: "danger",
  },
  {
    title: "Đang xử lý",
    icon: "doller-return",
    price: "3,001",
  },
];

export const ActivityData = [
  {
    title: "Sửa thông tin",
    subTitle: "8/3/2022",
    time: "1 ngày trước",
    dis: "Sửa lại",
    color: "primary",
  },
  {
    title: "Sửa thông tin",
    subTitle: "4/3/2022",
    time: "2 ngày trước",
    dis: "Sửa lại lần 2",
    color: "primary",
  },
  {
    title: "Sửa thông tin",
    subTitle: "1/3/2022",
    time: "4 ngày trước",
    dis: "Sửa lại lần 3",
    color: "primary",
  },
];

export const RecentSalesData = [
  {
    image: "1.jpg",
    title: "Jane Cooper",
    subTitle: "10 phút trước",
    badge: "Active",
  },
  {
    image: "2.jpg",
    title: "Brooklyn Simmons",
    subTitle: "19 phút trước",
    badge: "Active",
  },
  {
    image: "3.jpg",
    title: "Leslie Alexander",
    subTitle: "2 giờ trước",
    badge: "Active",
  },
  {
    image: "4.jpg",
    title: "Travis Wright",
    subTitle: "8 giờ trước",
    badge: "Active",
  },
  {
    image: "5.jpg",
    title: " Mark Green",
    subTitle: "1 ngày trước",
    badge: "Active",
  },
];

export const NoteLabels = [
  {
    title: "Báo cáo",
    color: "primary",
  },
  {
    title: "Thông tin",
    color: "success",
  },
  {
    title: "Thủ tục",
    color: "warning",
  },
  {
    title: "Ngân sách",
    color: "info",
  },
  {
    title: "Danh mục",
    color: "secondary",
  },
  {
    title: "+9",
    color: "light",
  },
];
